<template>
  <v-dialog v-model="show" max-width="800px" persistent scrollable>
    <v-card>
      <v-card-text v-if="formValues" style='height:auto'>
        <v-card-title mt-2 style="justify-content: center;">{{ $t('customerForm.title') }}</v-card-title>
        <validation-observer ref="form">
          <v-form>
            <v-col cols="12">
              <v-select
                v-model="formValues.civility"
                :items="civilityItems"
                :label="$t('customerForm.civility')"
                class="mt-4"
                clearable
                dense
              ></v-select>
              <validation-provider v-slot="{ errors }" :name="$t('customerForm.firstName')" rules="required">
                <v-text-field
                  v-model="formValues.first_name"
                  :error-messages="errors"
                  :label="$t('customerForm.firstName')"
                  class="required"
                  clearable
                  required
                >
                </v-text-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }" :name="$t('customerForm.lastName')" rules="required">
                <v-text-field
                  v-model="formValues.last_name"
                  :error-messages="errors"
                  :label="$t('customerForm.lastName')"
                  class="required"
                  clearable
                  required
                >
                </v-text-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }" :name="$t('customerForm.email')">
                <v-text-field
                  v-model="formValues.email"
                  :error-messages="errors"
                  :label="$t('customerForm.email')"
                  class="required"
                  clearable
                  required
                >
                </v-text-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }" :name="$t('customerForm.erpCustomerId')">
                <v-text-field
                  v-model="formValues.erp_customer_id"
                  :error-messages="errors"
                  :label="$t('customerForm.erpCustomerId')"
                  clearable
                  required
                >
                </v-text-field>
              </validation-provider>
              <vue-tel-input-vuetify
                ref="phone"
                v-model="formValues.phone"
                :defaultCountry="getDefaultCountry(countryCode)"
                :disabledFetchingCountry="true"
                :error-messages="phoneError"
                :placeholder="$t('customerForm.phone')"
                class="mt-1"
                clearable
                label=""
                mode="international"
                @input="validatePhone"
              />
            </v-col>
          </v-form>
        </validation-observer>
      </v-card-text>
      <v-card-actions class="pa-0 mt-2">
        <v-btn
          color="primary"
          style="width: 50%"
          tile
          @click="onSubmit"
        >
          {{ $t('customerForm.validate') }}
        </v-btn>
        <v-btn
          class="ml-0"
          color="secondary"
          style="width: 50%"
          tile
          @click="close">
          {{ $t('customerForm.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import isoCountries from 'i18n-iso-countries'

export default {
  name: 'CustomerDialog',
  props: {
    formValue: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    },
    countryCode: {
      type: String,
      required: false,
      default: 'FRA'
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      formValues: null,
      phoneError: []
    }
  },
  mounted () {
    isoCountries.registerLocale(require(`i18n-iso-countries/langs/${this.$i18n.locale}.json`))
    this.formValues = Object.assign({} ,this.formValue)
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    civilityItems () {
      return [
        { text: this.$t('customerForm.mr'), value: 'mr' },
        { text: this.$t('customerForm.mrs'), value: 'mrs' }
      ]
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async onSubmit () {
      const success = await this.$refs.form.validate()
      const phoneIsValid = this.formValues.phone ? this.formValues.phoneIsValid : true
      if (success && phoneIsValid) {
        this.$emit('validateForm', { data: this.formValues })
      }
    },
    validatePhone (number, phone) {
      if (number) {
        if (phone.isValid) {
          this.phoneError = []
          this.formValues.phone = phone.number.e164
          this.formValues.phoneIsValid = true
        } else {
          this.phoneError = this.$t('customerForm.phoneError')
          this.formValues.phoneIsValid = false
        }
      } else {
        this.formValues.phone = null
      }
    },
    getDefaultCountry (countryCode) {
      return isoCountries.alpha3ToAlpha2(countryCode)
    }
  }
}
</script>
